export const data = {
  name: 'Enter Your Name',
  reljs: ['I heard about JavaScript for the first time', 'I heard about JavaScript before but never tried to learn it', 'I heard about JavaScript before and I also have some knowledge about it', 'I know DOM Manipulation (Something like jQuery)', 'I know the Basics', 'I know the Advance Topics', 'I know ES6', 'I have worked with any one of them(Node JS/Express/React JS/Angular/Ember/Vue JS/React Native etc...)'],
  whyjs: 'Your Answer',
  seen: ['Google', 'Facebook', 'GitHub', 'Twitter', 'Email', 'Some other websites(Blogs etc...)'],
  rate: ['Very Good', 'Good', 'Not Good', 'Bad', 'Worst', 'No Comment'],
  dream: 'Your Answer',
  oneyear: 'Your Answer',
  feedback: 'Your Answer'
}



// WEBPACK FOOTER //
// ./src/data.js